import {isEmpty} from 'lodash/lang';
import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * reading endpoints
 */
export const fetchReadings = (page, perPage, userId) =>
  request.fetchList('/readings', undefined, page, perPage, undefined, {userId});

export const fetchReading = (readingId) => request.fetchDetail(`/readings/${readingId}`);

export const createReading = (payload) =>
  request.postJSON(
    '/readings',
    excludeObjNullValue({
      date: payload.date,
      book: payload.book,
      reaction: payload.reaction,
      common_image_id: payload.commonImageId,
      page: payload.page,
      comment: payload.comment,
    }),
  );

export const updateReading = (payload) =>
  request.putJSON(
    `/readings/${payload.readingId}`,
    excludeObjNullValue({
      date: payload.date,
      book: payload.book,
      reaction: payload.reaction,
      common_image_id: payload.commonImageId,
      page: payload.page,
      comment: payload.comment,
    }),
  );

export const deleteReading = (readingId) => request.deleteReq(`/readings/${readingId}`);

export const deleteReadingComment = (readingId) => request.deleteReq(`/readings/${readingId}/comment`);

export const fetchAdminReadings = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/admin-readings', q, page, perPage, sortOpts, extraParams);

export const createAdminReading = (payload) =>
  request.postJSON(
    '/admin-readings',
    excludeObjNullValue({
      reader_id: payload.reader.id,
      classroom_id: payload.classroom.id,
      date: payload.date,
      book_id_or_title: !isEmpty(payload.book) ? payload.book.id : payload.bookTitle,
      reaction: payload.reaction,
      common_image_id: payload.commonImageId,
      page: parseInt(payload.page),
      comment: payload.comment,
    }),
  );

export const updateAdminReading = (payload) =>
  request.putJSON(
    `/admin-readings/${payload.id}`,
    excludeObjNullValue({
      date: payload.date,
      book_id_or_title: !isEmpty(payload.book) ? payload.book.id : payload.bookTitle,
      reaction: payload.reaction,
      common_image_id: payload.commonImageId,
      page: parseInt(payload.page),
      comment: payload.comment,
    }),
  );
